'use strict';

import angular from 'angular';

const NavbarSvc = [
  'SidenavSvc', '$stateParams', '$state',
  function(SidenavSvc, $stateParams, $state) {
    // observer pattern http://stackoverflow.com/a/17558885
    var observerCallbacks = [];
    var navbar;
    var user;
    var groupRoles = {};
    var selectedGroupId;

    ////////// NAVBAR OBJECTS ///////////////////////////////////////////////
    var defaultNavbar = {
      rightNav: {
        right: true,
        navItems: [
          // {display: 'Sign Up', sref: 'signup', sortNum: 1},
          {
            display: 'Login',
            sref: 'login',
            sortNum: 2
          }
        ]
      }
    };

    // authenticated navbar
    var loggedInNav = {
      right: true,
      navItems: [
        {
          glyph: 'user',
          sref: 'me.personal',
          sortNum: 1
        },
        {
          display: 'Logout',
          sref: 'logout',
          sortNum: 2
        }
      ]
    };

    var adminNavItem = {
      type: 'dropdown',
      display: 'Admin',
      sortNum: 2,
      ddItems: [
        {
          display: 'Overview',
          sref: 'admin'
        }
        // ,
        // {display: 'Users', sref:'/admin/users'},
        // {display: 'Groups', sref:'/admin/groups'},
        // {display: 'Events', sref:'/admin/events'}
      ]
    };
    navbar = defaultNavbar;

    ////////// GROUPS NAV //////////////////////////////////////////////////
    function selectContextGrp(index, ctxId) {
      selectedGroupId = ctxId;
      updateNavbar();
      var group = groupRoles[ctxId];
      SidenavSvc.updateSidenav(group);
    }

    function initSelectGroupIndex() {
      // check url parameter if not already initialized
      selectedGroupId = selectedGroupId || $stateParams.ctxId;
      if(selectedGroupId && groupRoles[selectedGroupId]) { return; }
      /**
       * default to min of group id (assumed min is highest in tree hierarchy)
       * TODO: use path to determine highest group
       */
      for(var i in groupRoles) {
        if(!selectedGroupId) {
          selectedGroupId = i;
        } else if(Number(i) < Number(selectedGroupId)) {
          selectedGroupId = i;
        }
      }
    }

    function getGroupsNav(userGroups) {
      var grpNav = {};
      initSelectGroupIndex();
      for(var i in userGroups) {
        var g = userGroups[i];
        var display = g.group.name;
        if(g.type) {
          display += ' (' + g.type.name + ')';
        }
        grpNav[g.group.id] = {
          display,
          click: selectContextGrp, // include state change updates
          params: g.group.id,
          sref:
            'group.view.summary({ctxId:' + g.group.id + ', groupId:'
            + g.group.id + '})'
        };
      }
      SidenavSvc.updateSidenav(userGroups[selectedGroupId]);
      // default navigate to first group if not viewing group or user profile
      var currentState = $state.current.name;
      if(
        currentState.indexOf('group') < 0
        && currentState.indexOf('me') < 0
        && currentState.indexOf('stripeRedirect') < 0
        && currentState.indexOf('oauth') < 0
      ) {
        var params = {
          ctxId: selectedGroupId,
          groupId: selectedGroupId
        };
        $state.go('group.view.summary', params);
      }
      if(Object.keys(grpNav).length > 1) {
        return {
          display: grpNav[selectedGroupId].display,
          type: 'dropdown',
          ddItems: grpNav,
          sortNum: -1
        };
      } else {
        return {
          display: grpNav[selectedGroupId].display,
          sref: grpNav[selectedGroupId].sref,
          sortNum: -1
        };
      }
    }

    ////////// SET NAVBAR //////////////////////////////////////////////////
    function setNavbar() {
      navbar = defaultNavbar;
      if(user) {
        navbar = { rightNav: angular.copy(loggedInNav) };
        navbar.rightNav.navItems[0].display = user.preferredName || user.fname;

        // set groups based on groupRoles
        if(user.role === 'admin' && user.rootGroups.length > 0) {
          // first check for site admin and use root groups
          for(var i = 0; i < user.rootGroups.length; i++) {
            var rg = user.rootGroups[i];
            groupRoles[rg.id] = { group: rg}; // one role per group
          }
          navbar.rightNav.navItems.push(getGroupsNav(groupRoles));
        } else if(user.groupRoles && user.groupRoles.length > 0) {
          for(var j = 0; j < user.groupRoles.length; j++) {
            var g = user.groupRoles[j];

            // filter out member groups - admins only
            if(g.type && g.type.name === 'Member') { continue; }

            groupRoles[g.group.id] = g; // one role per group
          }
          navbar.rightNav.navItems.push(getGroupsNav(groupRoles));
        } else {
          // if no groups exist, navigate to personal page
          $state.go('me.personal');
        }

        // set root group
        navbar.leftNav = { navItems: [] };
        if(user.rootGroups && user.rootGroups.length === 1) {
          navbar.leftNav.navItems.unshift({
            type: 'brand',
            display: user.rootGroups[0].name,
            sortNum: -1
          });
        }

        // site admin role
        if(user.role === 'admin') {
          navbar.leftNav.navItems.push(adminNavItem);
        }
      }
      return navbar;
    }

    ////////// OBSERVER PATTERN ////////////////////////////////////////////
    //register an observer
    function registerObserverCallback(callback) {
      observerCallbacks.push(callback);
      if(navbar) { return callback(navbar); } // initialize
    }

    function updateNavbar() {
      var refreshedNavbar = setNavbar();
      angular.forEach(observerCallbacks, function(updateNavCb) {
        updateNavCb(refreshedNavbar);
      });
    }

    function setNavbarUser(u) {
      // reset navbar
      if(!u || user && user.id !== u.id) {
        groupRoles = {};
        selectedGroupId = null;
      }
      user = u;
      updateNavbar();
    }

    return {
      registerObserverCallback,
      setNavbarUser
    };
  }
];

export default NavbarSvc;
